import React from "react";
import { Lock, Zap, HeartHandshake, Hourglass } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";

const reasons = [
  { icon: Lock, title: "Discrétion totale", desc: "Votre histoire reste entre vous et Maître Diamma. Aucune information n'est jamais partagée." },
  { icon: Zap, title: "Résultats rapides", desc: "Des rituels précis et ciblés, pensés pour que les premiers changements arrivent vite." },
  { icon: HeartHandshake, title: "Écoute & bienveillance", desc: "Un accompagnement humain, sincère et sans jugement, quelle que soit votre situation." },
  { icon: Hourglass, title: "Des années d'expérience", desc: "Un savoir ancestral transmis de génération en génération et mis au service de La Réunion." },
];

const WhyChooseSection = () => (
  <section id="pourquoi-moi" className="relative py-24 md:py-32 lux-section-glow border-t border-amber-500/10" data-testid="pourquoi-moi-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionTitle eyebrow="Pourquoi me choisir" title="La confiance d'un" gold="vrai marabout"
        subtitle="Quand votre cœur ou votre vie est en jeu, vous méritez un accompagnement sérieux." />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
        {reasons.map((r, i) => (
          <Reveal key={r.title} delay={(i % 2) * 120}>
            <div className="lux-card h-full p-8 flex gap-5" data-testid={`reason-card-${i}`}>
              <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
                <r.icon className="w-6 h-6 text-amber-400" strokeWidth={1.5} />
              </div>
              <div>
                <h3 className="font-heading text-lg text-amber-100 mb-2">{r.title}</h3>
                <p className="text-zinc-400 text-sm md:text-base leading-relaxed">{r.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseSection;
